import Vue from 'vue';
import VueRouter from 'vue-router';

import ApiActions from '@/modules/api-actions';

import Login from '@/views/Login.vue';
import HomePage from '@/views/HomePage.vue';
import Welcome from '@/views/Welcome.vue';
import ThingsToNote from '@/views/ThingsToNote.vue';
import Tutorial from '@/views/Tutorial.vue';
import ChooseToStart from '@/views/ChooseToStart.vue';
import ScanBody from '@/views/ScanBody.vue';
import ScanBodyWithHandles from '@/views/ScanBodyWithHandles.vue';
import ShowResult from '@/views/ShowResult.vue';
import End from '@/views/End.vue';
import SettingUserData from '@/views/SettingUserData.vue';
import Analyzing from '@/views/Analyzing.vue';
import Discovery from '@/views/Discovery.vue';
import Close from '@/views/Close.vue';

import stampRoutes from './stamp';
import footScanRoutes from './footscan';
import mobileScanRoutes from './mobileScan';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/welcome',
    name: 'Welcome',
    component: Welcome,
    props: true,
  },
  {
    path: '/things_to_note',
    name: 'ThingsToNote',
    component: ThingsToNote,
  },
  {
    path: '/tutorial',
    name: 'Tutorial',
    component: Tutorial,
  },
  {
    path: '/choose_to_start',
    name: 'ChooseToStart',
    component: ChooseToStart,
  },
  {
    path: '/scan_body',
    name: 'ScanBody',
    component: ScanBody,
  },
  {
    path: '/scan_body_with_handles',
    name: 'ScanBodyWithHandles',
    component: ScanBodyWithHandles,
  },
  {
    path: '/show_result',
    name: 'ShowResult',
    component: ShowResult,
  },
  {
    path: '/home',
    name: 'HomePage',
    component: HomePage,
    props: true,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { public: true },
  },
  {
    path: '/setting_user_data',
    name: 'SettingUserData',
    component: SettingUserData,
    props: true,
  },
  {
    path: '/discovery',
    name: 'Discovery',
    component: Discovery,
  },
  {
    path: '/end',
    name: 'End',
    component: End,
  },
  {
    path: '/analyzing',
    name: 'Analyzing',
    component: Analyzing,
    props: true,
  },
  {
    path: '/_close_',
    name: 'Close',
    component: Close,
    meta: { public: true },
  },
  ...stampRoutes,
  ...footScanRoutes,
  ...mobileScanRoutes,
];

const router = new VueRouter({
  routes,
  mode: 'history',
});

router.beforeEach((to, from, next) => {
  if (!to.meta.public && !ApiActions.isAuthenticated()) {
    next({ name: 'Login', query: { redirect: to.fullPath }, replace: true });
  } else {
    next();
  }
});

export default router;
